// extracted by mini-css-extract-plugin
export default {"p_tye":"ccffd2a81d","slcted":"_308893eb69","slc_color":"ac3bbf1f9e","item_p":"_302d9aa57c","r0":"_8e6d522e6e"};